import Swal from "sweetalert2";

import * as AdminHandler from "../../components/js/modules/Admin";

import Button from "./Button";

import "../css/TicketInfo.css";

const TicketActions = ({ ticketData }) => {
    const claim = () => {
        if (!ticketData.user_permissions.canClaim) return;

        AdminHandler.claimTicket((res) => {
            if (res.status == "ok") {
                Swal.fire({
                    title: "Success",
                    text: "You have claimed this ticket.",
                    icon: "success",
                    confirmButtonText: "Ok"
                });
            } else {
                Swal.fire({
                    title: "Error",
                    text: "There was an issue while trying to claim this ticket, it could have already been claimed or the ticket is closed.",
                    icon: "error",
                    confirmButtonText: "Ok"
                });
            };
        });
    }

    const unclaim = () => {
        if (!ticketData.user_permissions.canUnclaim) return;

        AdminHandler.unclaimTicket((res) => {
            if (res.status == "ok") {
                Swal.fire({
                    title: "Success",
                    text: "You have unclaimed this ticket.",
                    icon: "success",
                    confirmButtonText: "Ok"
                });
            } else {
                Swal.fire({
                    title: "Error",
                    text: "There was an issue while trying to unclaim this ticket, it may be closed.",
                    icon: "error",
                    confirmButtonText: "Ok"
                });
            };
        });;
    }

    const open = () => {
        if (!ticketData.user_permissions.canOpen) return;

        AdminHandler.openTicket((res) => {
            if (res.status == "ok") {
                Swal.fire({
                    title: "Success",
                    text: "You have opened this ticket.",
                    icon: "success",
                    confirmButtonText: "Ok"
                }).then(() => {
                    //window.location.reload();
                });
            } else {
                Swal.fire({
                    title: "Error",
                    text: "There was an issue while trying to open this ticket, it may be deleted or opened already.",
                    icon: "error",
                    confirmButtonText: "Ok"
                });
            };
        });
    }

    const close = () => {
        if (!ticketData.user_permissions.canClose) return;

        AdminHandler.closeTicket((res) => {
            if (res.status == "ok") {
                Swal.fire({
                    title: "Success",
                    text: "You have closed this ticket.",
                    icon: "success",
                    confirmButtonText: "Ok"
                }).then(() => {
                    //window.location.reload();
                });
            } else {
                Swal.fire({
                    title: "Error",
                    text: "There was an issue while trying to close this ticket, it may be deleted or closed already.",
                    icon: "error",
                    confirmButtonText: "Ok"
                });
            };
        });
    }

    const deleteArchive = () => {
        if (!ticketData.user_permissions.canDelete) return;

        AdminHandler.deleteTicketArchive((res) => {
            if (res.status == "ok") {
                Swal.fire({
                    title: "Success",
                    text: "You have deleted this archive, it is unable to be undone.",
                    icon: "success",
                    confirmButtonText: "Ok"
                }).then(() => {
                    window.location.reload();
                });
            } else {
                Swal.fire({
                    title: "Error",
                    text: "There was an issue while trying to delete this archive, it may be deleted already.",
                    icon: "error",
                    confirmButtonText: "Ok"
                });
            };
        });
    }

    return <>
        <h3>Ticket Actions</h3>

        <div style={{gap: "5px"}} className="ticket-info-row ticket-actions-btns">
            {ticketData.user_permissions.canClaim &&
                <Button 
                    data-style="confirm"
                    data-size={1.2}
                    data-animation="raise"

                    onClick={claim}
                >
                    <i className="fa-solid fa-ticket"></i> Claim
                </Button>
            }

            {ticketData.user_permissions.canOpen &&
                <Button 
                    data-style="confirm"
                    data-size={1.2}
                    data-animation="raise"

                    onClick={open}
                >
                    <i className="fa-solid fa-rotate-left"></i> Open
                </Button>
            }

            {ticketData.user_permissions.canDelete &&
                <Button 
                    data-style="cancel"
                    data-size={1.2}
                    data-animation="raise"

                    onClick={deleteArchive}
                >
                    <i className="fa-solid fa-trash"></i> Delete
                </Button>
            }

            {ticketData.user_permissions.canUnclaim &&
                <Button 
                    data-style="info"
                    data-size={1.2}
                    data-animation="raise"

                    onClick={unclaim}
                >
                    <i className="fa-solid fa-ticket"></i> Unclaim
                </Button>
            }

            {ticketData.user_permissions.canClose &&
                <Button 
                    data-style="cancel"
                    data-size={1.2}
                    data-animation="raise"

                    onClick={close}
                >
                    <i className="fa-solid fa-circle-xmark"></i> Close
                </Button>
            }
        </div>
    </>
}

export default TicketActions;